import React from "react";

function Building09({ fill, ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill={fill ?? ""}
      viewBox="0 0 24 24"
    >
      <path
        d="M11.419 1.417c-.154.076-2.016 1.225-4.139 2.554C3.668 6.232 3.413 6.4 3.304 6.575a.805.805 0 0 0 .471 1.205c.184.054 1.161.06 8.327.05l8.118-.01.189-.111a.824.824 0 0 0 .061-1.377c-.349-.249-7.582-4.757-7.864-4.901-.265-.136-.325-.151-.601-.151-.269 0-.342.017-.586.137m3.149 3.163 2.528 1.58H6.904l2.518-1.577c1.385-.868 2.54-1.579 2.568-1.58.027-.002 1.188.708 2.578 1.577M5.814 9.197a.864.864 0 0 0-.524.396l-.11.187v8.44l.111.189a.82.82 0 0 0 1.418 0l.111-.189V9.78l-.111-.189c-.178-.303-.567-.474-.895-.394m4 0a.864.864 0 0 0-.524.396l-.11.187v8.44l.111.189a.82.82 0 0 0 1.418 0l.111-.189V9.78l-.111-.189c-.178-.303-.567-.474-.895-.394m4 0a.864.864 0 0 0-.524.396l-.11.187v8.44l.111.189a.82.82 0 0 0 1.418 0l.111-.189V9.78l-.111-.189c-.178-.303-.567-.474-.895-.394m4 0a.864.864 0 0 0-.524.396l-.11.187v8.44l.111.189a.82.82 0 0 0 1.418 0l.111-.189V9.78l-.111-.189c-.178-.303-.567-.474-.895-.394m-15 11.001a.862.862 0 0 0-.521.39.82.82 0 0 0 .298 1.121l.189.111h18.44l.189-.111a.82.82 0 0 0 0-1.418l-.189-.111-9.14-.006c-5.027-.003-9.197.007-9.266.024"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default Building09;
